import { render, staticRenderFns } from "./ChannelSharing.vue?vue&type=template&id=1f16826a&scoped=true&"
import script from "./ChannelSharing.vue?vue&type=script&lang=ts&"
export * from "./ChannelSharing.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelSharing.vue?vue&type=style&index=0&id=1f16826a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16826a",
  null
  
)

export default component.exports